/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Eastern_AsiaInputs */

const bn_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পূর্ব এশিয়া`)
};

const de_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostasien`)
};

const el_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανατολική Ασία`)
};

const en_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eastern Asia`)
};

const es_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia oriental`)
};

const fr_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asie de l’Est`)
};

const hi_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वी एशिया`)
};

const hu_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelet-Ázsia`)
};

const id_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia Timur`)
};

const it_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia orientale`)
};

const ja_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東アジア`)
};

const ko_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동아시아`)
};

const nl_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oost-Azië`)
};

const pl_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azja Wschodnia`)
};

const pt_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ásia Oriental`)
};

const ru_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восточная Азия`)
};

const sv_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Östra Asien`)
};

const tr_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğu Asya`)
};

const uk_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Східна Азія`)
};

const vi_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đông Á`)
};

const zh_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`东亚`)
};

const zh_hant_geo_label_eastern_asia = /** @type {(inputs: Geo_Label_Eastern_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東亞`)
};

/**
* | output |
* | --- |
* | "Eastern Asia" |
*
* @param {Geo_Label_Eastern_AsiaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_eastern_asia = /** @type {((inputs?: Geo_Label_Eastern_AsiaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Eastern_AsiaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_eastern_asia(inputs)
	if (locale === "de") return de_geo_label_eastern_asia(inputs)
	if (locale === "el") return el_geo_label_eastern_asia(inputs)
	if (locale === "en") return en_geo_label_eastern_asia(inputs)
	if (locale === "es") return es_geo_label_eastern_asia(inputs)
	if (locale === "fr") return fr_geo_label_eastern_asia(inputs)
	if (locale === "hi") return hi_geo_label_eastern_asia(inputs)
	if (locale === "hu") return hu_geo_label_eastern_asia(inputs)
	if (locale === "id") return id_geo_label_eastern_asia(inputs)
	if (locale === "it") return it_geo_label_eastern_asia(inputs)
	if (locale === "ja") return ja_geo_label_eastern_asia(inputs)
	if (locale === "ko") return ko_geo_label_eastern_asia(inputs)
	if (locale === "nl") return nl_geo_label_eastern_asia(inputs)
	if (locale === "pl") return pl_geo_label_eastern_asia(inputs)
	if (locale === "pt") return pt_geo_label_eastern_asia(inputs)
	if (locale === "ru") return ru_geo_label_eastern_asia(inputs)
	if (locale === "sv") return sv_geo_label_eastern_asia(inputs)
	if (locale === "tr") return tr_geo_label_eastern_asia(inputs)
	if (locale === "uk") return uk_geo_label_eastern_asia(inputs)
	if (locale === "vi") return vi_geo_label_eastern_asia(inputs)
	if (locale === "zh") return zh_geo_label_eastern_asia(inputs)
	return zh_hant_geo_label_eastern_asia(inputs)
});